import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SketchCircleFilledSvg from "@ant-design/icons-svg/es/asn/SketchCircleFilled";
import AntdIcon from "../components/AntdIcon";
var SketchCircleFilled = function SketchCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SketchCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SketchCircleFilled.displayName = 'SketchCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(SketchCircleFilled);